<template>
  <div class="mx-auto mt-16 max-w-7xl px-6 sm:mt-28 lg:px-8 relative">
    <h2 class="text-xl md:text-4xl font-bold md:leading-10 tracking-tight">
      {{ header }}
    </h2>
    <dl class="mt-10 space-y-8 divide-y divide-gray-900/10">
      <div
        v-for="(item, index) in faqs"
        :key="index"
        class="border-t border-ternGray"
      >
        <button
          @click="toggleAccordion(index)"
          class="w-full flex justify-between items-center py-4 md:py-6"
        >
          <span
            class="text-base md:text-lg leading-6 lg:col-span-5 text-left"
            >{{ item.question }}</span
          >
          <span class="ml-6 flex items-center text-ternGray">
            <svg
              class="h-6 w-6 transform"
              :class="{ 'rotate-180': item.isOpen }"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </span>
        </button>
        <div v-show="item.isOpen" class="px-4 pt-2">
          <p class="text-base leading-7 text-gray-600">{{ item.answer }}</p>
        </div>
      </div>
    </dl>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: 'FAQ',
      header: 'Frequently asked questions',
      faqs: [
        {
          question: 'How is Tilly different from ChatGPT?',
          answer:
            'Tilly is purpose-built for travel — no prompts, no guesswork. Unlike ChatGPT, Tilly creates complete, personalized itineraries in seconds based on your preferences, with maps and key details already built in. It handholds you through the entire process, helping you get exactly what you want from AI — without you even realizing it. Just answer five quick questions, and Tilly tailors your trip with smart recommendations for restaurants, experiences, transit, and local insights. Your itinerary is fully editable and shareable, with built-in weather, reservation tips, and even AI-powered suggestions you can drop right in. It’s a full travel workflow — and so fun to use! Try it to see for yourself.',
          isOpen: false,
        },
        {
          question: 'Is it free?',
          answer:
            "Every itinerary includes 1 free day so you can try it out before committing. After that, it's just $5 per trip or $60/year (currently 50% off at $29/year during our early launch). No surprise fees, cancel anytime. Just smarter, easier travel planning.",
          isOpen: false,
        },
      ],
    };
  },
  methods: {
    toggleAccordion(index) {
      this.faqs[index].isOpen = !this.faqs[index].isOpen;
    },
  },
};
</script>

<style>
.rotate-180 {
  transform: rotate(180deg);
}
</style>
